import { VF_TEXTAREA } from 'AppSrc/core/components/forms/form-base-components/v-f-textarea';
import {
  INLINE_ERRORS,
  // SILENT_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import { changeRequestRegressed } from './change-request-regressed';

const fieldId = 'failure_regression_details';

const initialValues = '';

const vFParams = {
  fieldTitle: 'If yes, please provide details of regression',
  placeholder: 'Enter text',
};

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  // When changeCauseIncident field is "Yes" will do validate
  const shouldValidate = values[changeRequestRegressed.id].includes('Yes');
  if (shouldValidate) {
    /* ERROR CHECKERS */
    const noValue = commonValidation.noValue(values[fieldId], VF_TEXTAREA);
    // const hasSpecialCharacter = commonValidation.textInput.hasSpecialCharacter(values[fieldId]);
    /* ADD ERRORS TO ERROR OBJECT */
    errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please provide a Summary' : null);
    // errors[INLINE_ERRORS].push((noValue && !optional) ? { withWarningSvg: true, className: 'textarea-area-warning' } : null);
    // errors[SILENT_ERRORS].push((hasSpecialCharacter) ? 'Special character < cannot be accepted in Ace' : null);
    // errors[INLINE_ERRORS].push((hasSpecialCharacter) ? { withWarningSvg: true, className: 'textarea-area-warning' } : null);
  }
  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

const provideDetailsOfRegression = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_TEXTAREA,
};

export { provideDetailsOfRegression };
